// extracted by mini-css-extract-plugin
module.exports = {"appWrapper":"AppLayout_appWrapper__3N5yU","mainComponentWrapper":"AppLayout_mainComponentWrapper__xMSkM"};